import React, { useState } from "react";
import Uploader from "../print/Uploader";
import PhoneMultiUploader from "./PhoneMultiUploader";

const PhoneUploadPage = ({
  mode,
  post_image_url,
  expired = false,
  upload_count = 0,
}) => {
  const [uploadedCount, setUploadedCount] = useState(upload_count);

  if (expired) {
    return (
      <div className="space-y-3 text-center">
        <p className="text-base font-medium text-stone-900">This upload link has expired.</p>
        <p className="text-sm text-stone-600">
          Return to your computer and generate a fresh QR code to continue.
        </p>
      </div>
    );
  }

  if (mode === "gallery_designer") {
    return (
      <div className="space-y-5">
        <PhoneMultiUploader
          postImageUrl={post_image_url}
          onUploadSaved={() => setUploadedCount((c) => c + 1)}
        />
        <p className="text-sm leading-relaxed text-stone-500">
          {uploadedCount > 0
            ? `${uploadedCount} ${uploadedCount === 1 ? "photo has" : "photos have"} been sent to your computer. Upload more or go back when you're done.`
            : "Select photos and they'll appear in the image tray on your computer automatically."}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <Uploader
        post_image_url={post_image_url}
        layout="button"
        buttonLabel="Upload photo"
        source="qr-handoff"
      />
      <p className="text-sm leading-relaxed text-stone-500">
        Choose one photo to send to your computer. You'll be prompted to continue there once the upload finishes.
      </p>
    </div>
  );
};

export default PhoneUploadPage;
